<template>
<div>
  <v-app-bar id="nav" color="black" theme="dark" location="top">
    <v-app-bar-nav-icon class="d-lg-none" @click="expand=!expand"></v-app-bar-nav-icon>
    <v-toolbar-title>
      <router-link to="/" id="logo"><img src="@/assets/logo.png" alt="Caos logo"></router-link>
    </v-toolbar-title>
    <v-spacer v-if="!user"></v-spacer>
    <v-toolbar-items id="navItems" :class="[user ? 'flex d-none d-lg-flex' : 'flex-not d-none d-md-flex', '']">
      <v-btn class="custom-font" to="/suits" variant="text">Custom Suits</v-btn>
      <v-btn class="custom-font" to="/stocksuits" variant="text">Stock Suits</v-btn>
      <v-btn class="custom-font" to="/workwear" variant="text">Work Wear</v-btn>
      <v-btn class="custom-font" to="/gallery" variant="text">Gallery</v-btn>
      <v-btn class="custom-font" to="/about" variant="text">About</v-btn>
      <v-btn class="custom-font" to="/contact" variant="text">Contact</v-btn>
      <v-btn variant="text" to="/cart" style="background-image: linear-gradient(to right,#f72f07 0%,#fc5e03 51%,#f72f07 100%);" class="white-text custom-font caos-font">Checkout({{cart}})</v-btn>
       <template v-if="user">
         <v-spacer></v-spacer>
        <v-btn v-for="item in admins" :key="item.route" class="white--text custom-font" variant="text" :to="item.route">{{item.title}}</v-btn>
        <v-btn class="red white--text" @click="logout" variant="text">Logout</v-btn>
      </template>
    </v-toolbar-items>
  </v-app-bar>


  <v-navigation-drawer v-model="expand" location="left" theme="dark" temporary>
    <v-container class="fill-height">
      <div class="d-flex flex-column fill-height w-100">
        <div>
          <v-list>
            <v-list-item v-for="item in items" :key="item.title" :to="item.route" class="white--text" active-class="red--text">
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item>
            <v-btn to="/cart" color="orange" class="white-text">Checkout({{cart}})</v-btn>
          </v-list>
        </div>
        <v-spacer></v-spacer>
        <div v-if="user">
          <v-list>
            <v-list-item v-for="item in admins" :key="item.title" :to="item.route" class="white--text" active-class="red--text">
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item>
          </v-list>
          <v-btn class="red white--text" @click="logout" variant="text">Logout</v-btn>
        </div>
      </div>
    </v-container>
  </v-navigation-drawer>
</div>
</template>

<script>
import * as firebase from "../firebase.js";
export default {
  data() {
    return {
      expand: false,
      items: [{
          title: 'Home',
          route: "/"
        },
        {
          title: 'Custom Suits',
          route: "/suits"
        },
        {
          title: 'Stock Suits',
          route: "/stocksuits"
        },
        {
          title: 'Work Wear',
          route: "/workwear"
        },
        {
          title: 'Gallery',
          route: "/gallery"
        },
        {
          title: 'About',
          route: "/about"
        },
        {
          title: 'Contact',
          route: "/contact"
        },
      ],
       admins:[{
          title: 'Orders',
          route: "/orders"
        },
        {
          title: 'Admin',
          route: "/admin"
        },
        {
          title: 'Messages',
          route: "/messages"
        }]
    }
  },
  methods:{
    logout() {
      firebase.auth.signOut().then(() => {
        this.$store.dispatch({
          type: 'removeAdmin'
          })
        this.$router.replace('/login');
      })
    },
  },
  computed: {
    cart(){
      return this.$store.getters.itemsInCart.length;
    },
    user(){
      return this.$store.getters.user;
    }
  }
}
</script>

<style scoped>
.flex{
  flex-basis:50%;
}
.flex-not{
  flex:0;
}
img {
  max-width: 180px;
  vertical-align: top;
}
.under{
  text-decoration: none;
}
.router-link-exact-active{
  opacity: .8;
}
#logo{
  opacity: 1;
}
.custom-font {
  font-family: poppins;
}
</style>
